import React, { useEffect, useState } from 'react';
import { createReportLink, publishReport, reportStatus, ReportStatus, unpublishReport } from '../reportAccess';
export function ReportSharingControls({quoteId,disabled=false}:{quoteId:string;disabled?:boolean}) {
 const [state,setState]=useState<ReportStatus|null>(null);
 const [busy,setBusy]=useState(false);
 const [notice,setNotice]=useState('');
 const [link,setLink]=useState('');
 const [reload,setReload]=useState(0);
 useEffect(()=>{let active=true;setState(null);setLink('');setNotice('');reportStatus(quoteId).then(s=>{if(active)setState(s);}).catch(()=>{if(active)setNotice('Could not check publication. Reload before sharing.');});return()=>{active=false;};},[quoteId,reload]);
 async function act(action:'publish'|'revoke'|'copy') {
  if(!state)return;
  if(action==='revoke'&&!window.confirm('Unpublish this report and revoke every existing report link? Republishing will require new links.'))return;
  setBusy(true);setNotice('');
  try {
   if(action==='publish'){setState(await publishReport(quoteId,state.revision));setNotice('Saved report published. Quote approval access is unchanged.');}
   if(action==='revoke'){setState(await unpublishReport(quoteId,state.revision));setLink('');setNotice('Report unpublished. All previous report links are revoked.');}
   if(action==='copy'){
    const url=await createReportLink(quoteId,state.revision);setLink(url);
    try {await navigator.clipboard.writeText(url);setNotice('Secure report-only link copied.');}
    catch {setNotice('Clipboard unavailable. Copy the secure link below.');}
   }
  } catch {setNotice('Action not confirmed. Reload publication state before trying again.');setState(null);setLink('');}
  finally {setBusy(false);}
 }
 const locked=busy||disabled||!state;
 return <section aria-label="Report sharing" className="p-4 border-t border-white/10 bg-slate-950 space-y-3">
  <p className="text-sm text-slate-300">{state?(state.published?'Published report':'Unpublished report'):'Checking publication…'} · Preview shows the saved report. Unsaved edits are not shared. Copy the link and email it manually.</p>
  <div className="flex flex-wrap gap-3">
   <button disabled={locked} onClick={()=>void act('publish')} className="text-brand-neonBlue disabled:opacity-40">{state?.published?'Update published report':'Publish report'}</button>
   <button disabled={locked||!state?.published} onClick={()=>void act('copy')} className="text-brand-neonBlue disabled:opacity-40">Copy report link</button>
   <button disabled={locked||!state?.published} onClick={()=>void act('revoke')} className="text-red-400 disabled:opacity-40">Unpublish and revoke links</button>
   {!state&&<button disabled={busy||disabled} onClick={()=>setReload(n=>n+1)}>Reload publication</button>}
  </div>
  {link&&<input aria-label="Secure report link" className="w-full bg-slate-900 text-white p-2" readOnly value={link}/>}
  {notice&&<p role="status" className="text-sm text-slate-300">{notice}</p>}
 </section>;
}
